<sb-auth-container [backgroundImage]="'/assets/auth/auth-v2-login.jpg'" [selectedLanguage]="selectedLang">
  <div auth-container class="w-full flex flex-col items-center justify-center">
    @if (migrationCompleted) {
      <div class="w-full md:w-[90%] flex flex-col items-center justify-center">
        <div class="w-full bg-[#FEF0C7] rounded-lg py-3 px-3.5 flex items-center justify-start gap-3 mb-8">
          <img class="w-6 h-6" src="assets/icons/info.svg" alt="info icon" />
          <div class="text-[#7A2E0E] text-base font-medium">{{ 'LOG_IN_WITH_YOUR_QUICKORDER_CREDENTIALS_TO_GET_STARTED_WITH_SHOPBOX' | translate }}</div>
        </div>
      </div>
    }

    <img src="assets/logos/Shopbox_Logo.svg" alt="login-bg" class="w-60 object-cover" />

    <div class="h-16 w-full flex items-center justify-center" [class.my-2]="errorValue && errorValue !== ''">
      <shopbox-error-toolbar [errors]="anyErrors" [errorValue]="errorValue"></shopbox-error-toolbar>
    </div>

    <div class="w-full md:w-[90%]">
      <div class="mb-6 text-2xl font-medium">{{'FORM.ACTIONS.LOGIN' | translate}}</div>
      <login-form (saveEmit)="submit($event)" [activeProgress]="activeProgress" [formDisable]="disableForm">
      </login-form>

      <div class="flex items-center justify-center text-center gap-1 mt-11">
        <span class="text-[#475467] text-base">{{'DONT_HAVE_AN_ACCOUNT' | translate}}</span>
        <button pRipple class="text-[#063F2E] text-base font-medium" (click)="goRegist()">{{'CREATE_ACCOUNT_HERE' | translate}}</button>
      </div>
    </div>

  </div>
</sb-auth-container>
